<template>
    <Dialog v-model="show" @input="$listeners.input" :title="title" width="450" :show-close-button="showCloseButton">
        <v-form ref="form" @submit.prevent="confirm">
            <Autocomplete id="comissionadoSelect"
                          label="Comissionado"
                          :rules="[$rules.required]"
                          :items="comissionados"
                          v-model="comissionado"
                          :params="params"
                          :cache-items='false'
                          item-value="idComissionado"
                          :item-text="formatNome"
                          placeholder="Selecione o comissionado"
                          :key="autoCompleteKey"
            />
            <div class="d-flex justify-center mt-4">
                <v-btn class="transition" color="primary" rounded @click="confirm">
                    Confirmar
                </v-btn>
            </div>
            <v-form />
        </v-form>
    </Dialog>
</template>

<script>
  export default {
    name: 'DialogComissionedHierarchy',
    props: {
      value: { type: Boolean, default: true },
      gerenteNegocio: String,
      comissionados: Array,
      showCloseButton: { type: Boolean, default: true },
      isEntrandoFluxoVenda: { type: Boolean, default: false }
    },
    data: () => ({
      title: 'SELECIONE O COMISSIONADO',
      comissionado: null,
      autoCompleteKey: 0
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          if (!val) {
            this.isEntrandoFluxoVendaComputed = false
          }
          this.$emit('input', val)
        }
      },
      params () {
        return {
          gerenteNegocio: this.gerenteNegocio
        }
      },
      isEntrandoFluxoVendaComputed: {
        get () {
          return this.isEntrandoFluxoVenda
        },
        set (val) {
          this.$emit('setarEntrandoFluxoVenda', val)
        }
      }
    },
    watch: {
      value (newValue, oldValue) {
        if (newValue && !oldValue) {
          this.comissionado = null
          this.autoCompleteKey++
        }
      }
    },
    methods: {
      fecharDialog () {
        if (this.isEntrandoFluxoVendaComputed) {
          this.$emit('voltarFluxoVenda')
        } else {
          this.$router.replace({ path: '/', query: { redirecionamentoPainelLateral: true } })
        }
        this.show = false
      },
      formatNome (comissionado) {
        return comissionado.codigoComissionado + ' - ' + comissionado.nomeComissionado
      },
      confirm () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$session.set('id_comissionado_venda', this.comissionado)
          this.fecharDialog()
        }
      }
    }
  }
</script>

<style scoped>

</style>
